import React, { useState } from 'react';
import { Dropdown } from 'primereact/dropdown';
import cross from 'assets/Images/cross.png';
import { FlexBox, Modal } from '@eltoro-ui/components';
import { lenses } from 'Components/CampaignExamplesWidget/components/CampaignExamplesModal/constants';
import CampaignModalMobileContent from 'Components/CampaignExamplesWidget/components/CampaignExamplesModal/components/CampaignModalContent/CampaignModalMobileContent';
import type { LensType } from 'Components/CampaignExamplesWidget/components/CampaignExamplesModal/constants';

import './CampaignExamplesModal.scss';

interface CampaignExamplesModalProps {
  onCancel: VoidFunction;
  redirectToLens: boolean;
}

export default function CampaignExamplesMobileModal({
  onCancel,
  redirectToLens,
}: CampaignExamplesModalProps) {
  const [selectedLens, setSelectedLens] = useState<LensType>(lenses[0]);

  return (
    <Modal className="campaign-example-modal">
      <img
        src={cross}
        onClick={onCancel}
        alt="cross"
        className="PersonalInfoForm__cross"
        role="presentation"
      />
      <FlexBox
        flexDirection="column"
        alignItems="flex-start"
        justifyContent="center"
        UNSAFE_className="mobile-example-content"
      >
        <p>Choose your goal</p>
        <Dropdown
          value={selectedLens}
          onChange={e => setSelectedLens(e.value)}
          options={lenses}
          optionLabel="label"
          placeholder="Select Lens"
          className="lens-example-dropdown"
          panelClassName="lens-example-dropdown-panel"
          highlightOnSelect={false}
        />

        <CampaignModalMobileContent selectedLens={selectedLens} redirectToLens={redirectToLens} />
      </FlexBox>
    </Modal>
  );
}
